<script>
   /**************************************************************/
   /* Svelte component for SensitivityPlot settings              */
   /**************************************************************/

   import Container from '../controls/Container.svelte';
   import Select from '../controls/Select.svelte';

   export let params;
   export let res;

   let resID = 'both';
   let zoom = 'off';

   $: params = {
      resID,
      zoom
   }
</script>

{#if res  }
<Container label="">
   <p class="title">Sensitivity plot</p>
</Container>
{#if Object.keys(res).length > 1 }
<Container label='Results:'>
   <Select id='resType' bind:value={resID} options={[...Object.keys(res), 'both']} />
</Container>
{/if}
<Container label='Zoom:'>
   <Select id='zoom' bind:value={zoom} options={['off', 'on']} />
</Container>
{/if}
